import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CardIconTitleDescription, RappiderCardWithIconTitleDescriptionListComponent } from '@rappider/rappider-components';
import { Page, ProjectModelWithRelations } from '@rappider/rappider-sdk';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rappider-manage-ui-home',
  standalone: true,
  imports: [
    CommonModule,
    RappiderCardWithIconTitleDescriptionListComponent,
    NzCollapseModule,
  ],
  templateUrl: './manage-ui-home.component.html',
  styleUrls: ['./manage-ui-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageUiHomeComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];

  pages: Page[] = [];

  projectModels: ProjectModelWithRelations[] = [];

  uiManagementCards?: CardIconTitleDescription[] = [
    {
      id: 'create-blank-page',
      title: 'Create Blank Page',
      key: 'create-blank-page',
      iconName: 'fa-regular fa-square-plus',
      description: 'Start with a clean slate and design your page from scratch with full customization options',
    },
    {
      id: 'create-ai-page',
      title: 'Create Page with Assistant',
      key: 'create-ai-page',
      iconName: 'fa-solid fa-sparkles',
      description: 'Leverage Assistant to quickly generate a professional page based on your requirements and specifications',
    }
  ];

  uiPageCards?: CardIconTitleDescription[] = [
    {
      id: 'uiPageLoading',
      title: 'Pages loading...',
      key: 'uiPageLoading',
      iconName: 'fa-solid fa-circle-notch fa-spin',
      description: 'Pages are loading...',
    }
  ];

  entityCards?: CardIconTitleDescription[] = [
    {
      id: 'entityLoading',
      title: 'Data entities loading...',
      key: 'entityLoading',
      iconName: 'fa-solid fa-circle-notch fa-spin',
      description: 'Data entities are loading...',
    }
  ];

  constructor(
    private store: Store<any>,
    private router: Router,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.subscribeToData();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }


  subscribeToData() {
    this.subscriptions = [
      this.subscribeToPages(),
      this.subscribeToProjectModels(),
    ];
  }

  subscribeToPages() {
    return this.store.select(state => state.page?.data).subscribe(pages => {
      this.pages = pages;

      this.mapPagesToCards();
    });
  }

  subscribeToProjectModels() {
    return this.store.select(state => state.projectModel?.data).subscribe(projectModels => {
      this.projectModels = projectModels;
      if (this.projectModels) {
        this.mapProjectModelsToCards();
      }
    });
  }

  mapPagesToCards() {
    this.uiPageCards = this.pages?.map(page => ({
      id: page.id,
      title: page.title,
      key: page.key,
      iconName: page.iconName ?? 'fa-regular fa-browser',
      description: page.description ?? undefined,
    }));

    this.cd.markForCheck();
  }

  mapProjectModelsToCards() {
    this.entityCards = this.projectModels.map(projectModel => ({
      id: projectModel.id,
      title: projectModel.title || projectModel.name,
      key: projectModel.name,
      iconName: projectModel.iconName ?? 'fa-regular fa-database',
      description: projectModel.description ?? undefined,
    }));

    this.cd.markForCheck();
  }

  onUiManagementCardCardClicked(card: any) {
    console.log('onUiManagementCardCardClicked ', card);
  }

  onUiPageCardCardClicked(card: any) {
    console.log('onUiPageCardCardClicked ', card);
    this.router.navigate(['/content-editor/', card.id]);
  }

  onEntityCardCardClicked(card: any) {
    console.log('onEntityCardCardClicked ', card);
    const basePath = '/ai/manage-ui/entity/';
    this.router.navigate([basePath, card.id]);
  }
}
